import { AppImageDisplayInfo, RenderImageType } from "client/Api/AppIcon/common";
import { createContext } from "react";
import { AppColorKind, AppColorViewModel } from "client/Api/Apps/common";
import { outOfContextCallError } from "client/Misc/reactUtils";
import {
	DimensionToRender,
	TileConditionalAccess,
	TileMaintenanceWindow
} from "../RenderState/common";

export enum InteractionState {
	Default = 1,
	Selectable = 2,
	Disabled = 3
}

export type TileContextData = {
	readonly id: number;
	readonly name: string;
	readonly color: AppColorViewModel;
	readonly icon: AppImageDisplayInfo;
	readonly dimension: DimensionToRender;
	readonly environmentAppId: number;
	readonly interactionState: InteractionState;
	readonly maintenanceWindow: TileMaintenanceWindow | nil;
	readonly conditionalAccess: TileConditionalAccess | nil;
	readonly appIsNotAccessible: boolean;
	readonly appIsLicensed: boolean;
	readonly shouldHideName: OptionalModel<boolean>;
};

export const TileContext = createContext<TileContextData>({
	id: 0,
	name: "",
	color: { kind: AppColorKind.Inherit },
	icon: {
		renderType: RenderImageType.Raster,
		imageUrl: ""
	},
	get dimension() {
		return outOfContextCallError("TileContext", "dimension")();
	},
	environmentAppId: 0,
	interactionState: InteractionState.Default,
	maintenanceWindow: null,
	conditionalAccess: null,
	appIsLicensed: false,
	appIsNotAccessible: false,
	shouldHideName: { isSet: false }
});
